export const seoContent = {
    es: {
        title: 'Mejor Suscripción IPTV en España y Europa | Liguee1',
        description: 'Suscripción IPTV premium: +79.000 canales, +249.000 películas y series, HD/4K, deporte en directo, servidores estables, soporte 24/7. Compatible con todos tus dispositivos.',
    },
};
